module.exports = __webpack_public_path__ + "img/LogoConcursos.b9bc52fc.png";